import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AppContainer from './AppContainer';
import { RELEASE_PROP_TYPES } from '../../shared/experiments/phasedRelease/config';
import HomepageComponent from '../homepage/HomepageComponent';
import homepageMetaData from '../homepage/model/metaData';
import trackingAdapter from '../homepage/tracking/trackingAdapter';
import { parseUrlChannel, channelObjects } from '../../shared/model/constants/channels';
import { USER_AGENT_PROP_TYPES, RECENT_SEARCH_PROP_TYPES } from '../homepage/model/types';
import { EXPERIMENTS_REGISTRY_PROP_TYPE } from '../../shared/experiments/abTesting/lib/types';
import { PAGE_TYPE_HOME_PAGE } from '../../shared/tracking/tealium/constants';

const HomepageApp = ({ params, location }) => {
  const { ForSale } = channelObjects;
  const {
    userAgent,
    channel = ForSale.url,
    error,
    isSignedIn,
    token,
    recentSearches,
    releases,
    experimentsManager,
    hostname,
  } = params;
  const { query, search, pathname } = location;
  const currentChannel = query.channel || channel;
  const currentChannelObject = parseUrlChannel(currentChannel);
  const handlePageTracking = () => {
    trackingAdapter.trackPageEvent({
      channelObject: currentChannelObject,
      experimentsManager,
      homepageType: PAGE_TYPE_HOME_PAGE,
    });
    window.RCA = window.RCA || {};
  };
  const populateMetaData = () => homepageMetaData({}, pathname, hostname, query);

  useEffect(() => {
    handlePageTracking();
  }, [params.channel]);

  return (
    <AppContainer
      channel={channel}
      error={error}
      metaData={populateMetaData}
      isSignedIn={isSignedIn}
      token={token}
      headerProps={{ pathname, search }}
      userAgent={userAgent}
      releases={releases}
      experimentsManager={experimentsManager}
    >
      <HomepageComponent currentChannel={currentChannelObject} recentSearches={recentSearches} />
    </AppContainer>
  );
};

HomepageApp.metaData = homepageMetaData;

HomepageApp.propTypes = {
  params: PropTypes.shape({
    userAgent: USER_AGENT_PROP_TYPES.isRequired,
    hostname: PropTypes.string,
    channel: PropTypes.string,
    error: PropTypes.object,
    isSignedIn: PropTypes.bool.isRequired,
    token: PropTypes.string,
    releases: RELEASE_PROP_TYPES.isRequired,
    recentSearches: RECENT_SEARCH_PROP_TYPES,
    experimentsManager: EXPERIMENTS_REGISTRY_PROP_TYPE,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      channel: PropTypes.string,
    }).isRequired,
    search: PropTypes.string,
  }).isRequired,
};

export default HomepageApp;
